<template>
  <div class="zip">
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div>
      <input
        ref="fileupload"
        accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
        type="file"
        @change="handleFileUpload"
        :name="name"
      />
    </div>
    <br />
    <div>
      <fg-input :type="`text`" :value="result" :readonly="true"></fg-input>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    newData: null,
    oldData: null,
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    title: {
      default: "",
    },
    value: {
      default: null,
    },
    result: {
      default: null,
    },
    name: {
      default: null,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", null);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const reader = new FileReader();
        this.tempUpload = true;
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.newData = reader.result;
        });
        this.$emit("input", event.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss">
.zip {
  background: #f2f2f2;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 15px;
}
</style>
